import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { DawaAddress } from './dawaaddress';
import { DawaAddressFull } from './dawaaddressfull';
import { AddressInsurance } from 'next-typescript-api';

@Injectable()
export class DawaService {
    constructor(private http: HttpClient) {}

    getDawaAddressById(addressId: string): Observable<DawaAddressFull> {
        const url = `https://dawa.aws.dk/adresser/${addressId}`;
        return this.http.get<DawaAddressFull>(url);
    }

    getDawaAddressByCustomerAddress(address: AddressInsurance): Observable<DawaAddress[]> {
        if (address == null) {
            return of([]);
        }

        let addressString = '';
        if (address.streetName) {
            addressString += address.streetName + ' ';
        }
        if (address.streetNo) {
            addressString += address.streetNo + ' ';
        }
        if (address.floor) {
            addressString += address.floor + ' ';
        }
        if (address.doorSide) {
            addressString += address.doorSide + ' ';
        }
        if (address.zipcode) {
            addressString += address.zipcode + ' ';
        }
        if (address.city) {
            addressString += address.city + ' ';
        }

        return this.getDawaAddressByText(addressString);
    }

    getDawaAddressByText(addressText: string): Observable<DawaAddress[]> {
        if (addressText == null || addressText.length < 1) {
            return of([]);
        }

        const url = 'https://dawa.aws.dk/adresser/autocomplete?q=' + encodeURIComponent(addressText) + '&format=json';
        return this.http.get<DawaAddress[]>(url);
    }
}
